var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from "@material-ui/core";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { usePlaylistGenres } from "frontend/src/domain/playlists";
import { usePlayerTrackId } from "frontend/src/domain/player-track-queue";
import { useAudio } from "frontend/src/domain/audio";
import { AudioControlButton } from "frontend/src/ui/audio-control-button";
import { TrackRow } from "frontend/src/ui/track-row";
import { usePageModel, usePlay } from "./model";
import { Skeleton } from "@material-ui/lab";
import { TableRowsSkeleton } from "../../../../../../ui/table-skeleton";
var Row = React.memo(function (_a) {
    var index = _a.index, loading = _a.loading, selected = _a.selected, playing = _a.playing, onPlay = _a.onPlay, onPause = _a.onPause, _b = _a.track, title = _b.title, duration = _b.duration, track = __rest(_b, ["title", "duration"]);
    var genres = track.type === "public"
        ? track.genres.map(function (genre) { return genre.title; }).join(", ")
        : "Рекламный ролик";
    var artist = track.type === "public" ? track.artist : "";
    var play = function () { return onPlay({ selected: selected, index: index }); };
    return (React.createElement(TrackRow, { isSelectedForPlayer: selected },
        React.createElement(TableCell, null,
            React.createElement(AudioControlButton, { isLoading: loading, onPause: onPause, onPlay: play, isPlaying: playing })),
        React.createElement(TableCell, null, title),
        React.createElement(TableCell, null, artist),
        React.createElement(TableCell, null, genres),
        React.createElement(TableCell, null, duration.formatted)));
});
var Rows = function (_a) {
    var tracks = _a.tracks, onTrackPause = _a.onTrackPause, onTrackPlay = _a.onTrackPlay;
    var currentPlayerTrackId = usePlayerTrackId();
    var audio = useAudio();
    return (React.createElement(React.Fragment, null, tracks.map(function (track, index) {
        var selected = track.id === currentPlayerTrackId;
        var playing = selected && audio.playing;
        var loading = selected && audio.loading;
        return (React.createElement(Row, { key: track.id, index: index, track: track, selected: selected, playing: playing, loading: loading, onPause: onTrackPause, onPlay: onTrackPlay }));
    })));
};
var Page = function () {
    var _a, _b, _c;
    var playlist = usePageModel();
    var _d = usePlay(playlist !== null && playlist !== void 0 ? playlist : { id: -1, title: "", tracks: [] }), play = _d.play, pause = _d.pause;
    var genres = usePlaylistGenres(playlist === null || playlist === void 0 ? void 0 : playlist.tracks);
    return (React.createElement(Box, null,
        React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Typography, { variant: "h5" }, (_a = playlist === null || playlist === void 0 ? void 0 : playlist.title) !== null && _a !== void 0 ? _a : React.createElement(Skeleton, null))),
        React.createElement(Box, { component: Paper, p: 2, mt: 1 },
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "body2" }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C:"),
                React.createElement(Typography, { variant: "h6", display: "inline" }, (_b = playlist === null || playlist === void 0 ? void 0 : playlist.duration.formatted) !== null && _b !== void 0 ? _b : React.createElement(Skeleton, null))),
            React.createElement(Box, { mt: 1 },
                React.createElement(Typography, { variant: "body2" }, "\u0412\u0441\u0435\u0433\u043E \u0442\u0440\u0435\u043A\u043E\u0432:"),
                React.createElement(Typography, { variant: "h6", display: "inline" }, (_c = playlist === null || playlist === void 0 ? void 0 : playlist.trackCount) !== null && _c !== void 0 ? _c : React.createElement(Skeleton, null))),
            React.createElement(Box, { mt: 1 },
                React.createElement(Typography, { variant: "body2" },
                    "\u0416\u0430\u043D\u0440\u044B:",
                    React.createElement("br", null),
                    typeof genres === "object" ? (genres.map(function (genre) { return (React.createElement(Box, { display: "inline-block", mr: 1, mt: 1, component: "span", key: genre },
                        React.createElement(Chip, { label: genre, component: "span" }))); })) : (React.createElement(Skeleton, null))))),
        React.createElement(Box, { component: Paper, mt: 1 },
            React.createElement(TableContainer, null,
                React.createElement(Table, null,
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null, null),
                            React.createElement(TableCell, null, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                            React.createElement(TableCell, null, "\u0418\u0441\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C"),
                            React.createElement(TableCell, null, "\u0416\u0430\u043D\u0440\u044B"),
                            React.createElement(TableCell, null, "\u0414\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C"))),
                    React.createElement(TableBody, null, playlist ? (React.createElement(Rows, { tracks: playlist === null || playlist === void 0 ? void 0 : playlist.tracks, onTrackPause: pause, onTrackPlay: play })) : (React.createElement(TableRowsSkeleton, { rows: 15, columns: 5 }))))))));
};
export var ViewPlaylistPage = function () { return (React.createElement(BusinessOwnerLayout, null,
    React.createElement(Page, null))); };
